import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OtpService {

  constructor(private http: HttpClient) { }

  /**
   * Calls the API to generate an OTP for a given mobile number.
   * @param mobileNumber The 9-digit mobile number.
   * @returns An Observable of the API response.
   */
  generateOtp(mobileNumber: string): Observable<any> {
    const params = new HttpParams().set('phoneNumber', mobileNumber);
    return this.http.post<any>(`${environment.baseUrlUserService}/v1/otp/generate`, params); 
  }

  /**
   * Calls the API to verify an OTP for a given mobile number.
   * @param mobileNumber The mobile number.
   * @param otp The 6-digit OTP.
   * @returns An Observable of the API response.
   */
  verifyOtp(mobileNumber: string, otp: string): Observable<any> {
    const payload = { 'phoneNumber': mobileNumber, otp: otp };
    return this.http.post<any>(`${environment.baseUrlUserService}/v1/otp/verify`, payload); 
  }
}